import {useEffect, useState} from 'react';

export enum ScreenSize {
  ExtraSmall = 0,
  Small = 1,
  Medium = 2,
  Large = 3,
  ExtraLarge = 4,
}

export const useScreenSize = () => {
  const [screenSize, setScreenSize] = useState<ScreenSize>(ScreenSize.Medium);

  useEffect(() => {
    const updateScreenSize = () => {
      const width = window.innerWidth;

      if (width < 576) {
        setScreenSize(ScreenSize.ExtraSmall);
      } else if (width < 768) {
        setScreenSize(ScreenSize.Small);
      } else if (width < 992) {
        setScreenSize(ScreenSize.Medium);
      } else if (width < 1200) {
        setScreenSize(ScreenSize.Large);
      } else {
        setScreenSize(ScreenSize.ExtraLarge);
      }
    };

    updateScreenSize();

    window.addEventListener('resize', updateScreenSize);

    return () => {
      window.removeEventListener('resize', updateScreenSize);
    };
  }, []);

  return screenSize;
};
